<template>
    <div class="orchestration-view" v-if="status">
        <IndependentAcceleratorsView />
        <ReportTemplate v-if="isGridVisible" :table-props="orchestrationColumns" :project-param-id="projectParamId"
            :orchestration-param-id="orchestrationParamId" @toggleTabs="toggleTabs" />
    </div>
</template>

<script>
import ReportTemplate from "@/components/ReportTemplate.vue";
import { pageViews, type } from "../utils/util";
import Store from "../vuex/store.js";
import IndependentAcceleratorsView from "./IndependentAcceleratorsView.vue";

export default {
    name: pageViews.ORCHESTRATION_VIEW,
    methods: {
        setValuesToStore(type) {
            Store.commit("setType", type);
        },
    },
    components: {
        ReportTemplate,
        IndependentAcceleratorsView,
    },
    data() {
        return {
            status: true,
            showTabs: false,
            currentTabComponent: null,
            isGridVisible: true,
            uploadConfigs: {
                action: "generator",
                actionLabel: "Generator",
                title: "Orchestration Config Generator",
                type: type.ORCHESTRATION,
                accept: ".zip",
            },
            orchestrationColumns: {
                type: type.ORCHESTRATION,
                isMultiSelectionAllowed: false,
                configs: [
                    { 
                        name: "orchestrationId", 
                        label: "Orchestration ID", 
                        order: 0,
                        checked: true,
                        defaultSelected: true,
                    },
                    {
                        name: "userId",
                        label: "User ID",
                        order: 1,
                        checked: false,
                    },
                    {
                        name: "projectId",
                        label: "Project ID",
                        order: 2,
                        checked: true,
                        defaultSelected: true,
                    },
                    {
                        name: "usecaseIds",
                        label: "Use Case IDs",
                        order: 3,
                        checked: false,
                    },
                    {
                        name: "usecaseNames",
                        label: "Use Case Names",
                        order: 4,
                        checked: true,
                        defaultSelected: true,
                        textAlign: "left",
                    },
                    {
                        name: "unsupported_processes",
                        label: "Unsupported Processes",
                        order: 5,
                        checked: false,
                    },
                    {
                        name: "missing_processes",
                        label: "Missing Processes",
                        order: 5,
                        checked: false,
                    },
                    {
                        name: "unsupported_functions",
                        label: "Unsupported Functions",
                        order: 6,
                        checked: false,
                    },
                    {
                        name: "error_functions",
                        label: "Error Functions",
                        order: 7,
                        checked: false,
                    },
                    {
                        name: "requestDate",
                        label: "Request Date",
                        order: 8,
                        checked: true,
                        defaultSelected: true,
                        type: "date",
                    },
                    {
                        name: "lastModifiedDate",
                        label: "Last Modified Date",
                        order: 9,
                        checked: false,
                        type: "date",
                    },
                    {
                        name: "status",
                        label: "Status",
                        order: 10,
                        checked: true,
                        defaultSelected: true,
                    },
                    // {
                    //     name: "isDeleted",
                    //     label: "Is Deleted",
                    //     order: 11,
                    //     checked: false,
                    // },
                    {
                        name: "remarks",
                        label: "Remarks",
                        order: 12,
                        checked: false,
                    },
                ],
                actions: {
                    download: {
                        label: 'Request Download'
                    },
                }
            }
        };
    },
    props: ["projectParamId", "orchestrationParamId"],
}

</script>
<style scoped>
.links-container {
    margin-top: 20px;
    /* Adjust this value as needed */
}

.links-container a {
    margin-right: 10px;
    /* Adjust this value as needed */
    cursor: pointer;
    text-decoration: underline;
    color: blue;
}
</style>